import { DATAGRID_TABLE_CELL_WIDTH, HIDE_TARGET_IN_RUN_TYPE } from '../../../../utils/constants';

const columns = (renderDrillstringCell, renderDrillFluidCell, renderTargetsEditAction, renderWellboreInitializationEditAction, properties, hydraulicParameterData, dialogParameter) => {
  const hideWellBore = hydraulicParameterData.some(item => item.parameter === 'MW');

  return [
    {
      field: 'drillStringsId',
      headerName: 'Drillstrings',
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 40,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderDrillstringCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'drillFluidsId',
      headerName: 'Drilling Fluids',
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 40,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderDrillFluidCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'wellBoreInitialization',
      headerName: 'Wellbore Initialization',
      flex: 1,
      hide: hideWellBore,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 50,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderCell: renderWellboreInitializationEditAction,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'target_data',
      headerName: 'Target',
      hide: HIDE_TARGET_IN_RUN_TYPE.includes(dialogParameter),
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 50,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderCell: renderTargetsEditAction,
      headerAlign: 'center',
      align: 'center',
    }
  ];
};
export default columns;
